import styled from 'styled-components'

import Text from '../../../core/Text/Text'

export const InputMessage = styled(Text)`
  position: absolute;
  left: 0;
  bottom: -${props => props.theme.spacings.medium};
  white-space: nowrap;
`
